module.exports = __webpack_public_path__ + "static/img/Application.38f2fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prizeo/imgs/browse/Application.jpg
// module id = 2087
// module chunks = 0